/* eslint-disable camelcase */

export const images = [
    '/assets/placeholder/1.jpg',
    '/assets/placeholder/2.jpg',
    '/assets/placeholder/3.jpg',
    '/assets/placeholder/4.jpg',
    '/assets/placeholder/5.jpg',
    '/assets/placeholder/6.jpg',
    '/assets/placeholder/7.jpg',
    '/assets/placeholder/8.jpg',
    '/assets/placeholder/9.jpg',
];

export const landscapeImages = [
    '/assets/placeholder/2.jpg',
    '/assets/placeholder/4.jpg',
    '/assets/placeholder/5.jpg',
    '/assets/placeholder/7.jpg',
    '/assets/placeholder/9.jpg',
];

export const videos = [
    'https://vimeo.com/257717109',
    'https://vimeo.com/249968820',
    'https://vimeo.com/946821430'
];

export const quotes = [
    '<p data-textsize="lg" class="lg">Life is a series of natural and spontaneous changes. Don’t resist them; that only creates sorrow. Let reality be reality. Let things flow naturally forward in whatever way they like. – Lao Tzu</p>',
    '<p data-textsize="lg" class="lg">The best ideas are usually those that come without effort, out of the blue. The great intellectual creations come easily. Only a great person can create something great, and such a one works without strain. — John Ruskin</p>',
    '<p data-textsize="lg" class="lg">The follies of others are obvious, but our own hide from us; we love to parse others’ missteps but we cover up our own, as the cheat conceals the false die. It is in the nature of men to lay blame: we see others’ mistakes while our own passions swell, carrying us ever farther from improvement. — Buddhist wisdom</p>',
    '<p data-textsize="lg" class="lg">When we are clear about things, we have knowledge; with knowledge, we seek the path of truth; when the search is rewarded, the heart becomes good; with the heart made good, the moral view of things that leads to virtue is attained. — Confucius</p>',
];

export const course = {
    title: "Click me, I'm editable!",
    description: "<p>Unleash your creativity and make this course uniquely yours.</p><p>Swap images, videos, and documents. Create new screens and change the theme design. Let's get started!</p>",
    theme: {
        preset: 'coassemble',
        font: 'Poppins',
        colours: {
            standard: {
                primary: '#446CFC',
                headings: '#151F6D',
                background: '#DAF6FF'
            },
            cover: {
                primary: '#446CFC',
                headings: '',
                background: '#151F6D',
                pattern: '#446CFC'
            }
        }
    },
    start: {
        display_duration: false,
        duration: '5'
    },
    finish: {
        title: 'You’re all done!',
        description: '<p>How was your course experience?</p><p><em>This is the Finish screen. Here you can give your viewers a goodbye message, and ask for feedback.</em></p>',
        display_title: true,
        display_description: true,
        display_button: true,
        display_pattern: true,
        display_feedback: true,
        display_confetti: true,
        button_label: 'Create your own course',
        button_url: 'https://coassemble.com',
        button_style: 'transparent'
    },
    screens: [
        {
            sequence: 1,
            title: 'Some tips for getting started',
            type: {
                id: 46,
                name: 'iaChecklist',
                title: 'Checklist',
                icon: 'checklist.svg',
            },
            object: {
                items: [
                    { description: 'Edit this checklist item' },
                    { description: 'Explore and try editing other screens in this course' },
                    { description: 'Add a screen yourself' },
                    { description: 'Don’t worry about making it perfect - grab the Share link to show it to others' }
                ],
                display_title: true,
                display_description: false
            }
        },
        {
            sequence: 2,
            title: 'Transform it!',
            description: '<p><em>Watch the video, then replace it with your own! Use the display options 👁️ from the toolbar above to show or hide the screen title or description.</em></p>',
            type: {
                id: 56,
                name: 'video',
                title: 'Video',
                icon: 'video.svg'
            },
            object: {
                images: [
                    {
                        image_path: 'https://vimeo.com/946821430',
                        image_mode: 'fit',
                    }
                ],
                display_title: true,
                display_description: true,
                display_image_title: null,
                display_image_description: null
            }
        },
        {
            sequence: 3,
            title: 'Our Product Mission',
            description: '<p data-textsize="lg" class="lg">Our mission is to empower trainers worldwide with the ability to transform and enrich online training.</p><p><em>This is an example Text and image screen. Change the layout options to suit your content, you can hide any of the page elements, including the title, description, and image!</em></p>',
            type: {
                id: 55,
                name: 'textAndImage',
                title: 'Text and image',
                icon: 'text.svg'
            },
            object: {
                text_alignment: 'left',
                display_title: true,
                display_description: true,
                drag_index: 2,
                mode: 'inline-reverse',
                layout: 'right',
                image: 'https://static.coassemble.com/upload/1456/image/04a2071d-0dbb-4c21-8449-1937996f8268.png',
                image_mode: 'fill',
                title_size: 'one'
            },
            asset: 'https://static.coassemble.com/upload/1456/image/04a2071d-0dbb-4c21-8449-1937996f8268.png'
        },
        {
            sequence: 4,
            title: 'Coassemble Brand Book',
            description: '<p><em>This is an example document screen. To replace it, click the delete button and upload your own!</em></p><p><em>You can choose to display your document inline, or as a download only file.</em></p>',
            type: {
                id: 51,
                name: 'document',
                title: 'Document',
                icon: 'documentScreen.svg'
            },
            object: {
                url: 'https://static.coassemble.com/upload/34879/document/08ee7aae-ae6e-482c-946e-0e785f45e16b.pdf',
                name: 'Coassemble_Brand_Short_sm.pdf',
                mime_type: 'application/pdf',
                disposition: 'inline',
                display_title: true,
                display_description: true
            }
        },
        {
            sequence: 5,
            title: 'FAQs',
            description: '<p><em>This is an example ‘Accordion’ screen. Great for fitting lots of information into a small amount of space. Try it, by adding a new item.</em></p>',
            type: {
                id: 31,
                name: 'iaAcronym',
                title: 'Accordion',
                icon: 'accordion.svg'
            },
            object: {
                letters: [
                    {
                        title: 'How do I share a course? ',
                        description: '<p>There are two ways to share a course in Coassemble. </p><p><strong>Share with a link</strong></p><p>The easiest, and most common way to share a course is by copying the course share link, and sharing it anywhere you want. Anyone with the link can view your course. </p><p><strong>Export a SCORM file</strong></p><p>If you have an LMS, you can export your Course as a SCORM file and upload it to your LMS. </p><p></p>'
                    },
                    {
                        title: 'How many courses can I create?',
                        description: '<p>You can create as many courses as you like. You have unlimited access!</p>'
                    },
                    {
                        title: 'How many viewers can I have? ',
                        description: '<p>There is no limit on the number of viewers who can see your course. Share it with as many people as you like!</p>'
                    }
                ],
                mode: 'plus',
                display_title: true,
                display_description: true
            }
        },
        {
            sequence: 6,
            title: 'Quiz',
            description: null,
            type: {
                id: 58,
                name: 'quiz',
                title: 'Quiz',
                icon: 'quiz.svg'
            },
            object: {
                display_title: false,
                display_description: false
            },
            questions: [
                {
                    text: '<p>Complete the following sentence: </p>',
                    questionType: {
                        id: 3,
                        title: 'Fill in the blank',
                        klass: 'dropdown',
                        template: 'dropDown',
                        icon: 'dropDown.svg',
                    },
                    feedback: [],
                    segments: [
                        {
                            type: 'text',
                            text: 'Our mission is to empower trainers worldwide with the ability to',
                            objClass: 'text'
                        },
                        {
                            type: 'answer',
                            options: [
                                {
                                    correct: true,
                                    text: 'transform and enrich'
                                },
                                {
                                    correct: false,
                                    text: 'limit and control'
                                }
                            ],
                            objClass: 'answer'
                        },
                        {
                            type: 'text',
                            text: 'online training.',
                            objClass: 'text'
                        }
                    ],
                    klass: 'dropdown'
                },
                {
                    text: '<p>The easiest, and most common way to share a course is with:</p>',
                    questionType: {
                        id: 7,
                        title: 'Multiple choice',
                        klass: 'simple',
                        template: 'multipleChoiceImg',
                        icon: 'multipleChoice.svg',
                    },
                    feedback: [],
                    answers: [
                        {
                            label: 'a course share link',
                            value: '1',
                            measure: null,
                            amount: null,
                            dimensions: null,
                            alt: null,
                            source: null,
                            fake: null
                        },
                        {
                            label: 'a SCORM object',
                            value: '',
                            measure: null,
                            amount: null,
                            dimensions: null,
                            alt: null,
                            source: null,
                            fake: null
                        },
                        {
                            label: 'an email',
                            value: '',
                            measure: null,
                            amount: null,
                            dimensions: null,
                            alt: null,
                            source: null,
                            fake: null
                        }
                    ],
                    is_case_sensitive: false,
                    klass: 'simple'
                }
            ],
            asset: null,
            asset_alt_text: null
        }
    ]
};

export const carousel = [
    {
        title: 'Practice healthy habits',
        description: "<p><span data-textcolor=\"#353535\" style=\"color: #353535\">Unleash your creativity and make this course uniquely yours.</span></p><p><span data-textcolor=\"#353535\" style=\"color: #353535\">Swap images, videos, and documents. Create new screens and change the theme design. Let's get started!</span></p>",
        image: 'https://static.coassemble.com/upload/34885/image/3422d6d7-3f49-4d6c-b74d-01d9c4b56b60.jpg',
        start: {
            start: true,
            legacy: false,
            overlay: 0,
            display_button: true,
            display_description: true,
            display_duration: false,
            display_pattern: true,
            text_alignment: 'center',
            button_label: 'Start course',
            button_style: 'solid',
            mode: 'inline-full',
            layout: 'background',
            duration: '5',
            link_type: 'next',
            title_size: 'one',
            drag_index: 2,
            text_colour: '#0F171F',
            title_colour: '#253778'
        },
        finish: {},
        theme: {},
        screens: []
    },
    {
        start: {},
        finish: {},
        theme: {},
        screens: [
            {
                sequence: 1,
                title: 'FAQs',
                description: '<p><em>This is an example ‘Accordion’ screen. Great for fitting lots of information into a small amount of space. Try it, by adding a new item.</em></p>',
                type: {
                    id: 31,
                    name: 'iaAcronym',
                    title: 'Accordion',
                    icon: 'accordion.svg'
                },
                object: {
                    letters: [
                        {
                            title: 'How do I share a course? ',
                            description: '<p>There are two ways to share a course in Coassemble. </p><p><strong>Share with a link</strong></p><p>The easiest, and most common way to share a course is by copying the course share link, and sharing it anywhere you want. Anyone with the link can view your course. </p><p><strong>Export a SCORM file</strong></p><p>If you have an LMS, you can export your Course as a SCORM file and upload it to your LMS. </p><p></p>',
                            class: null,
                            colour: null
                        },
                        {
                            title: 'How many courses can I create?',
                            description: '<p>You can create as many courses as you like. You have unlimited access!</p>',
                            class: null,
                            colour: null
                        },
                        {
                            title: 'How many viewers can I have? ',
                            description: '<p>There is no limit on the number of viewers who can see your course. Share it with as many people as you like!</p>',
                            class: null,
                            colour: null
                        }
                    ],
                    mode: 'plus',
                    display_title: true,
                    display_description: true
                }
            }
        ]
    },
    {
        start: {},
        finish: {},
        theme: {},
        screens: [
            {
                sequence: 1,
                title: 'Work retreat in 2023',
                description: null,
                type: {
                    id: 56,
                    name: 'video',
                    title: 'Video',
                    icon: 'video.svg'
                },
                object: {
                    images: [
                        {
                            image_path: 'https://vimeo.com/851120443?share=copy'
                        }
                    ],
                    bg_colour: '#446cfc',
                    display_title: true,
                    display_description: false,
                    display_image_title: null,
                    display_image_description: null,
                }
            }
        ]
    },
    {
        start: {},
        finish: {},
        theme: {},
        screens: [
            {
                sequence: 1,
                title: 'Get to know the leadership team',
                description: '<p data-textsize="h2" class="h2" style="text-align: center"><span data-textcolor="#343483" style="color: #343483">Get to know the Leadership team</span><span data-textcolor="#c06767" style="color: #c06767"> </span><strong>👋</strong></p>',
                type: {
                    id: 45,
                    name: 'caseStudy',
                    title: 'Flashcards',
                    icon: 'caseStudy.svg'
                },
                object: {
                    elements: [
                        {
                            title: 'Juggler, CEO 👋 ',
                            image: 'https://static.coassemble.com/upload/34885/image/f82aaaef-b5fb-45be-adcd-d18124a03443.jpg',
                            image_alt: null,
                            image_position: null,
                            image_source: null,
                            description: '<p><span data-textcolor="#ffffff" style="color:#ffffff;">Our fearless leader, </span></p>',
                            card_back: null,
                            btn_text: null,
                            colour: '#7abcd3',
                            ratio: 1.3333333333333333,
                            mode: 'fill',
                            offset_x: 0,
                            offset_y: 0
                        },
                        {
                            title: 'Juggler, CEO 👋  (Copy)',
                            image: 'https://static.coassemble.com/upload/34885/image/f82aaaef-b5fb-45be-adcd-d18124a03443.jpg',
                            image_alt: null,
                            image_position: null,
                            image_source: null,
                            description: '<p><span data-textcolor="#ffffff" style="color:#ffffff;">Our fearless leader, </span></p>',
                            card_back: null,
                            btn_text: null,
                            colour: '#2b90a9',
                            ratio: 1.3333333333333333,
                            mode: 'fill',
                            offset_x: 0,
                            offset_y: 0
                        },
                        {
                            title: 'Juggler, CEO 👋  (Copy)',
                            image: 'https://static.coassemble.com/upload/34885/image/f82aaaef-b5fb-45be-adcd-d18124a03443.jpg',
                            image_alt: null,
                            image_position: null,
                            image_source: null,
                            description: '<p><span data-textcolor="#ffffff" style="color:#ffffff;">Our fearless leader, </span></p>',
                            card_back: null,
                            btn_text: null,
                            colour: '#1d7288',
                            ratio: 1.3333333333333333,
                            mode: 'fill',
                            offset_x: 0,
                            offset_y: 0
                        },
                        {
                            title: 'Juggler, CEO 👋',
                            image: 'https://static.coassemble.com/upload/34885/image/6bd2de42-5db1-43c8-8a09-0dc8e6f0130a.jpg',
                            image_alt: null,
                            image_position: null,
                            image_source: null,
                            description: '<p><span data-textcolor="#ffffff" style="color:#ffffff;">Our fearless leader, </span></p>',
                            card_back: null,
                            btn_text: null,
                            colour: '#e0e3ec',
                            ratio: 1.7777777777777777,
                            mode: 'background',
                            offset_x: 0,
                            offset_y: 0
                        },
                        {
                            title: 'Painter, Founder',
                            image: 'https://static.coassemble.com/upload/34885/image/4666e69a-15e9-4c5f-8312-f1116ee0c592.jpg',
                            image_alt: null,
                            image_position: null,
                            image_source: null,
                            description: '<p><span data-textcolor="#f6f6f6" style="color:#f6f6f6;">Our fearless leader, Jacinta</span></p>',
                            card_back: 'Answer 1',
                            btn_text: null,
                            colour: '#e0e3ec',
                            ratio: 1.7777777777777777,
                            mode: 'background',
                            offset_x: 0,
                            offset_y: 0
                        },
                        {
                            title: '👋 CEO',
                            image: 'https://static.coassemble.com/upload/34885/image/24bb8a9e-8c3e-4b4a-965e-3854f11f45b6.jpg',
                            image_alt: null,
                            image_position: null,
                            image_source: null,
                            description: null,
                            card_back: 'Answer 2',
                            btn_text: null,
                            colour: '#e0e3ec',
                            ratio: null,
                            mode: 'background',
                            offset_x: null,
                            offset_y: null
                        }
                    ],
                    legacy: false,
                    display_image: true,
                    display_title: false,
                    display_description: true,
                    display_image_title: true,
                    display_image_description: true,
                    display_background_colour: true,
                    text_alignment: 'left',
                    smart_colour: null,
                    title_size: null,
                    title_colour: null
                },
                questions: [],
                asset: null,
                asset_alt_text: null
            }
        ]
    },
    {
        start: {},
        finish: {},
        theme: {},
        screens: [
            {
                sequence: 1,
                title: 'Say "hello" to Lara!',
                description: '<p data-textsize="lg" class="lg"><span data-textcolor="#272d67" style="color: #272d67">Our mission is to empower trainers worldwide with the ability to transform and enrich online training.</span></p><ul><li><p><em><span data-textcolor="#272d67" style="color: #272d67">She has worked for Wells Fargo Bank as Director of Sales</span></em></p></li><li><p><em><span data-textcolor="#272d67" style="color: #272d67">VP of Sales at Target USA</span></em></p></li><li><p><em><span data-textcolor="#272d67" style="color: #272d67">Her favorite food is Pasta Carbonara (especially in Italy)</span></em></p></li><li><p><em><span data-textcolor="#272d67" style="color: #272d67">She has a cat called Lula</span></em></p></li><li><p><em><span data-textcolor="#272d67" style="color: #272d67">She loves chatting on Slack so message anytime</span></em></p></li></ul>',
                type: {
                    id: 55,
                    name: 'textAndImage',
                    title: 'Text and image',
                    icon: 'text.svg'
                },
                object: {
                    text_alignment: 'left',
                    display_duration: null,
                    display_title: true,
                    display_description: true,
                    duration: null,
                    drag_index: 2,
                    mode: 'inline-reverse',
                    layout: 'right',
                    image: 'https://static.coassemble.com/upload/34885/image/2a1e0b15-e3a8-457a-bc43-7517df6d121e.jpg',
                    image_mode: 'fill',
                    bg_colour: '#FB99AA',
                },
                asset: 'https://static.coassemble.com/upload/34885/image/2a1e0b15-e3a8-457a-bc43-7517df6d121e.jpg'
            }
        ]
    },
    {
        start: {},
        finish: {},
        theme: {},
        screens: [
            {
                sequence: 1,
                title: 'Ergonomics at home',
                description: '<p><img src="https://static.coassemble.com/upload/34885/image/1399d938-11d9-4b29-b0db-d9d09aea219d.jpg" data-media-width="6" data-media-inline="false"></p>',
                type: {
                    id: 58,
                    name: 'quiz',
                    title: 'Quiz',
                    icon: 'quiz.svg'
                },
                object: {
                    display_title: true,
                    display_description: true
                },
                questions: [
                    {
                        published_id: null,
                        id: 2892277,
                        text: '<p>Choose what’s not the best ergonomics at home</p>',
                        image: null,
                        image_alt: null,
                        image_source: null,
                        questionType: {
                            id: 7,
                            hidden: false,
                            title: 'Multiple choice',
                            klass: 'simple',
                            template: 'multipleChoiceImg',
                            icon: 'multipleChoice.svg',
                            order: 0,
                            premium: false
                        },
                        feedback_correct: null,
                        feedback_incorrect: null,
                        feedback: [],
                        curriculum_elements: [],
                        answers: [
                            {
                                label: 'Standing desk',
                                value: '',
                                measure: null,
                                amount: null,
                                dimensions: null,
                                alt: null,
                                source: null,
                                fake: null
                            },
                            {
                                label: 'Rocking chair',
                                value: '1',
                                measure: null,
                                amount: null,
                                dimensions: null,
                                alt: null,
                                source: null,
                                fake: null
                            },
                            {
                                label: 'Eye height monitor',
                                value: '',
                                measure: null,
                                amount: null,
                                dimensions: null,
                                alt: null,
                                source: null,
                                fake: null
                            }
                        ],
                        used_answers: null,
                        is_case_sensitive: false,
                        klass: 'simple'
                    }
                ],
                asset: null,
                asset_alt_text: null
            }
        ]
    }
];
